import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { MiniSubheader, Body } from "../Typography";

const HoverBehaviorStyle = css`
  transition: box-shadow 0.3s ease-out, transform 0.6s ease-out;
  border: ${({ theme }) => theme.colors.gray700} solid 1px;
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0px 12px 32px 0px ${({ theme }) => theme.colors.gray500};
  }
`;

const MediumCardSizeStyle = css`
  width: 20rem;
  height: 10rem;
  padding: 1rem 1.5rem;
  background-color: ${({ theme }) => theme.colors.white};
  ${({ theme }) => theme.media.tabletUp`
    width: 25rem;
    height: 12.5rem;
  `};
`;

const StyledCard = styled.div`
  ${HoverBehaviorStyle}
  ${MediumCardSizeStyle}
`;

const StyledCardTitle = styled(MiniSubheader)`
  margin-top: 0;
`;

const LineClampBodyText = styled(Body)`
  ${props =>
    props.lineClampNumber &&
    css`
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: ${props.lineClampNumber};
      -webkit-box-orient: vertical;
    `}
`;

const SubheaderWithBodyCard = ({
  titleText,
  bodyText,
  className,
  lineClampNumber
}) => {
  return (
    <StyledCard className={className}>
      <StyledCardTitle>{titleText}</StyledCardTitle>
      <LineClampBodyText lineClampNumber={lineClampNumber}>
        {bodyText}
      </LineClampBodyText>
    </StyledCard>
  );
};

SubheaderWithBodyCard.propTypes = {
  titleText: PropTypes.string,
  bodyText: PropTypes.string
};

SubheaderWithBodyCard.defaultProps = {
  titleText: "",
  bodyText: ""
};

export { MediumCardSizeStyle };
export default SubheaderWithBodyCard;
